export default "__VITE_ASSET__RKBke8Is__"